import React from 'react';
import PropTypes from 'prop-types';
import Eyecon from '../../../Form/Eyecon';
import OverlayIcons from '../../../../assets/svg/OverlayIcons';
import styles from './OverlaysContent.module.scss';

const OverlaySelectionRow = (props) => {
  const getIcon = () => {
    const Icon = OverlayIcons[props.overlay.icon];

    if (Icon == null) {
      return OverlayIcons.Sun;
    } else {
      return Icon;
    }
  };

  const isEnabled = (id) => {
    const foundIdx = props.activeOverlays.findIndex((overlay) => overlay.id == id);
    return foundIdx > -1;
  };

  const toggleOverlay = (overlay) => {
    return (e) => props.onChange(e, overlay);
  };

  const Icon = getIcon();

  return (
    <div className={styles.overlaySelectionRow}>
      <div className={styles.iconContainer}>
        <Icon color={props.overlay.iconColor} width={24} height={24} />
      </div>
      <div className={styles.overlayName}>
        {props.overlay.name}
      </div>
      <Eyecon
        isOn={isEnabled(props.overlay.id)}
        onChange={toggleOverlay(props.overlay)}
      />
    </div>
  );
};

OverlaySelectionRow.propTypes = {
  activeOverlays: PropTypes.array,
  onChange: PropTypes.func,
  overlay: PropTypes.object,
};

export default OverlaySelectionRow